import React from 'react'
import { HtmlParse } from 'utils'
import logoPrime from 'images/icons/logo-jumbo-prime.svg'
import Price from 'components/Price'
import style from './style.scss'

const OrderSummary = React.forwardRef(({
    discount,
    discountColaborator,
    discountTcenco,
    pickUpDiscount,
    subTotal,
    selectedDelivery,
    PrimeDiscount,
    isCatPayment,
    shipping,
    selectedSla,
    forceShipping,
    promoCencoPrime,
}, stickyRef) => {

    return (
        <div className='totalizer-order-summary' ref={stickyRef} >
            <h2 className="totalizer-order-summary-title">Resumen del pedido</h2>

            {!!subTotal && discountColaborator < 0 && (
                <div className={'cart-totalizer-discount-colaborador' + (discountTcenco ? '' : ' colaborador')}>
                    <div className="cart-totalizer-colaborador-span-container">
                        <span className="cart-totalizer-span">Dcto. Colaborador</span>
                    </div>
                    <span className="cart-totalizer-total-discount-colaborador-price">
                        - <Price price={discountColaborator * -1} />
                    </span>
                </div>
            )}

            {!isCatPayment && !!subTotal && !!discount && (
                <div className={'cart-totalizer-regular-price' + (discountTcenco ? '' : ' regular-price')}>
                    <span className="cart-totalizer-regular-price-title">Descuento</span>
                    <span className="cart-totalizer-regular-price-discount">
                        - <Price price={discount / 100} className="cart-totalizer-regular-discount-price" />
                    </span>
                </div>
            )}

            {discountTcenco > 0 && isCatPayment && (
                <div className={'cart-totalizer-discount-wrap' + (discount !== discountTcenco && discountTcenco ? '' : ' regular-price') + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                    <div className={'cart-totalizer-discount-cenco' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                        <div className="cart-totalizer-discount-span-container">
                            <span className={'cart-totalizer-span-discount' + ' colaborador'}>Dcto. T. Cencosud Scotiabank</span>
                        </div>
                        <span className={'cart-totalizer-total-discount-cenco-price' + ' colaborador'}>
                            - <Price price={discountTcenco} className="cart-totalizer-total-discount-cenco-price" />
                        </span>
                    </div>
                </div>
            )}

            {!isCatPayment && (discount > 0 || pickUpDiscount > 0) && (
                <div className={'cart-totalizer-discount-wrap' + (discount !== discountTcenco && discountTcenco ? '' : ' regular-price') + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                    {discountTcenco > 0 && (
                        <div className={'cart-totalizer-discount-cenco' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                            <div className="cart-totalizer-discount-span-container">
                                <span className={'cart-totalizer-span-discount' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                                    Dcto. T. Cencosud Scotiabank
                                </span>
                            </div>
                            <span className={'cart-totalizer-total-discount-cenco-price' + (discountColaborator ? ' colaborador' : '')}>
                                - <Price price={discountTcenco} className="cart-totalizer-total-discount-cenco-price" />
                            </span>
                        </div>
                    )}
                    {!isCatPayment && !!subTotal && !!discount && (
                        <div className="cart-totalizer-discount">
                            <div>
                                <span className="cart-totalizer-span-discount">Dcto.</span>
                                <span className="cart-totalizer-span-all-payment">Otro medio de pago</span>
                            </div>
                            <span className="cart-totalizer-total-discount-price">
                                - <Price price={discount / 100} className="cart-totalizer-total-discount-price" />
                            </span>
                        </div>
                    )}
                    {!selectedDelivery && pickUpDiscount > 0 && (
                        <div className="cart-totalizer-discount">
                            <div>
                                <span className="cart-totalizer-span-discount">Dcto.</span>
                                <span className="cart-totalizer-span-all-payment">Retiro al auto</span>
                            </div>
                            <span className="cart-totalizer-total-discount-price">
                                - <Price price={pickUpDiscount} className="cart-totalizer-total-discount-price" />
                            </span>
                        </div>
                    )}
                </div>
            )}

            {PrimeDiscount > 0 && (
                <div className={'cart-totalizer-discount-prime'}>
                    <div className="cart-totalizer-discount-wrapper">
                        <span className={'cart-totalizer-span-discount'}>Dcto. Prime</span>
                        <span className={'cart-totalizer-total-discount-price'}>
                            - <Price price={PrimeDiscount} className="cart-totalizer-total-discount-price" />
                        </span>
                    </div>
                </div>
            )}

            {shipping >= 0 && (selectedSla || forceShipping) && (
                <div className="cart-totalizer-delivery">
                    <div className="cart-totalizer-delivery-wrapper">
                        <span className="cart-totalizer-delivery-title">{selectedDelivery ? 'Costo de entrega' : 'Costo de Servicio'}</span>
                        <span className="cart-totalizer-delivery-price">
                            {promoCencoPrime && (
                                <span className="cart-totalizer-delivery-prime">
                                    <i className="logo-prime">{HtmlParse(logoPrime)}</i>
                                    <Price price={promoCencoPrime} />
                                </span>
                            )}
                            <Price price={shipping / 100} />
                        </span>
                    </div>
                </div>
            )}
            
        </div>
    )
})

OrderSummary.displayName = 'OrderSummary'

export default OrderSummary